/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AbsenceReason } from '../model/absenceReason';
import { GetAbsenceEntriesResponse } from '../model/getAbsenceEntriesResponse';
import { GetAbsenceReasonsResponse } from '../model/getAbsenceReasonsResponse';
import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { AbsenceV2ServiceInterface }                            from './absenceV2.serviceInterface';


@Injectable()
export class AbsenceV2Service implements AbsenceV2ServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceEntries2(organization?: string, login?: string, from?: number, to?: number, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceEntriesResponse>;
    public getAbsenceEntries2(organization?: string, login?: string, from?: number, to?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceEntriesResponse>>;
    public getAbsenceEntries2(organization?: string, login?: string, from?: number, to?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceEntriesResponse>>;
    public getAbsenceEntries2(organization?: string, login?: string, from?: number, to?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (login !== undefined && login !== null) {
            queryParameters = queryParameters.set('login', <any>login);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceEntriesResponse>(`${this.basePath}/absence/v2/entries`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAbsenceReasonsForUser1(organization?: string, login?: string, locale?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAbsenceReasonsResponse>;
    public getAbsenceReasonsForUser1(organization?: string, login?: string, locale?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAbsenceReasonsResponse>>;
    public getAbsenceReasonsForUser1(organization?: string, login?: string, locale?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAbsenceReasonsResponse>>;
    public getAbsenceReasonsForUser1(organization?: string, login?: string, locale?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAbsenceReasonsResponse>(`${this.basePath}/absence/v2/reasons`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param updateAllAbsences 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAbsenceReasonForUser1(organization?: string, login?: string, updateAllAbsences?: boolean, body?: AbsenceReason, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setAbsenceReasonForUser1(organization?: string, login?: string, updateAllAbsences?: boolean, body?: AbsenceReason, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setAbsenceReasonForUser1(organization?: string, login?: string, updateAllAbsences?: boolean, body?: AbsenceReason, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setAbsenceReasonForUser1(organization?: string, login?: string, updateAllAbsences?: boolean, body?: AbsenceReason, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (updateAllAbsences !== undefined && updateAllAbsences !== null) {
            queryParameters = queryParameters.set('updateAllAbsences', <any>updateAllAbsences);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/absence/v2/reason`,
            body,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
